import { useState, useEffect, useMemo, useRef } from 'react';

export function useLocalStorage (key, initialState) {
	const id = useMemo(() => Math.random() * 100, []);
	const [state, setState] = useState(() => {
		const data = window.localStorage.getItem(key);
		if (!data) return initialState;
		return JSON.parse(data);
	});

	const _setState = (newValue) => {
		setState(newValue);
		window.localStorage.setItem(key, JSON.stringify(newValue));
		const event = new window.CustomEvent('currentTabStorage', {
			detail: {
				id,
				data: newValue
			}
		});
		window.dispatchEvent(event);
	};

	useEffect(() => {
		const handler = (event) => {
			if(event.key !== key) return ;
			console.log('cross tab storage event', event);
			setState(JSON.parse(event.newValue));
		};
		const currentTabHandler = (event) => {
			if (event.detail.id === id) return;
			console.log('current tab storage event', event);
			setState(event.detail.data);
		};
		window.addEventListener('storage', handler);
		window.addEventListener('currentTabStorage', currentTabHandler);
		return () => {
			window.removeEventListener('storage', handler);
			window.removeEventListener('currentTabStorage', currentTabHandler);
		};
	}, [key]);

	return [state, _setState];
}
